import { createContext, useContext } from 'react';

import type { Bootstrap, SourceId } from '@/data-sources/contract';

export type DataSourceContextValue = {
  source: SourceId;
  /** '' for the live tree, '/test' for the mock tree. Links are written canonically and prefixed with this. */
  basePath: string;
  bootstrap: Bootstrap;
  /** The filter state the page reads and writes (`state.filters[filterScope]`). */
  filterScope: string;
};

export const DataSourceContext = createContext<DataSourceContextValue | null>(null);

/** The active source, its base path and its bootstrap. Only valid under `DataSourceLayout`. */
export function useDataSource(): DataSourceContextValue {
  const value = useContext(DataSourceContext);
  if (!value) throw new Error('useDataSource must be used under <DataSourceLayout>.');
  return value;
}

/** Same, but null outside a source tree (e.g. the 404 page, the router link). */
export function useOptionalDataSource(): DataSourceContextValue | null {
  return useContext(DataSourceContext);
}
